import { render, staticRenderFns } from "./SendCardTopUp.vue?vue&type=template&id=397e3e87&scoped=true"
import script from "./SendCardTopUp.vue?vue&type=script&lang=js"
export * from "./SendCardTopUp.vue?vue&type=script&lang=js"
import style0 from "./SendCardTopUp.vue?vue&type=style&index=0&id=397e3e87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397e3e87",
  null
  
)

export default component.exports